var Slider = function() {

	this.init = function() {

		this.slider();

	}

	this.slider = function() {
		var auto = $('#SliderAutomatic').val() == 'true';
		var time = $('#TimeSlider').val();
		time = time*1000;

		if($('.slider-for .slider-item').length > 3){
			$('.slider-for').slick({
				autoplay: auto,
				  autoplaySpeed: time,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				swipe: false,
				asNavFor: '.slider-nav',
				responsive: [{
					breakpoint: 992,
					settings: {
						dots: true,
						swipe: true
					}
				}]
			});
			$('.slider-nav').slick({
				slidesToShow: 3,
				slidesToScroll: false,
				asNavFor: '.slider-for',
				dots: false,
				infinite: true,
				arrows: false,
				centerMode: true,
				focusOnSelect: true,
				responsive: [{
					breakpoint: 992,
					settings: "unslick"
				}]
			});
		}else{
			$('.slider-for').slick({
				autoplay: auto,
				autoplaySpeed: time,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				swipe: false,
				//asNavFor: '.slider-nav',
				responsive: [{
					breakpoint: 992,
					settings: {
						dots: true,
						swipe: true
					}
				}]
			});
			$('.slider-nav').slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				asNavFor: '.slider-for',
				centerMode: true,
				focusOnSelect: true,
				responsive: [{
					breakpoint: 992,
					settings: "unslick"
				}]
			});

			$('.slider-for').on('afterChange', function(event, slick, currentSlide, nextSlide){
				var indexSlide = $('.slider-for').slick('slickCurrentSlide');
				$('.slider-nav .slick-current').removeClass('slick-current');
				$('.slider-nav .slick-slide[data-slick-index="'+indexSlide+'"]').addClass('slick-current');
			});
		}
	}

	return this.init();

}
